import http from './http';

export default {
  getResumes: (classroomId) => http.get(`/api/resumes/classrooms/${classroomId}/resumes/?page_size=1000`),
  getResume: (classroomId, userId) => http.get(`/api/resumes/classrooms/${classroomId}/resumes/${userId}/`),
  postResume: (classroomId, data) => http.post(`/api/resumes/classrooms/${classroomId}/resumes/`, { data }),
  getComments: (classroomId, userId) => http.get(`/api/resumes/classrooms/${classroomId}/resumes/${userId}/comments/`),
};
